import type { Device } from "luxedo-data"
import { openOverlay } from "overlay"
import DeviceImageCapture from "./DeviceImageCapture.svelte"
import { LuxedoRPC } from "luxedo-rpc"

export function openDeviceImageCaptureOverlay(device: Device) {
	const beforeUnload = async (e: BeforeUnloadEvent) => {
		e.preventDefault()
		await LuxedoRPC.api.device.dev_camera_record(device.id, 0)
	}

	const handleClose = async () => {
		window.removeEventListener("beforeunload", beforeUnload)
	}

	openOverlay(DeviceImageCapture, {
		classOverlay: "no-pad",
		beforeClose: handleClose,
		props: { device },
	})

	window.addEventListener("beforeunload", beforeUnload)
}
